<template>
  <SelectorPanel
    type="grdCountries"
    text="Countries"
    :disabled="disabled"
    :force-close="forceClose"
    :url-path="urlPath"
    :disable-close="true"
    :force-full-screen="true"
    @open="handleOpen"
    content-class="hyp-dialog-risk-card-text"
    content-wrapper-class="hyp-dialog-risk-card"
  >
    <template v-slot:append>
      <PulseAndRiskDefinitions
        :rating-id="selectedRatingId"
        :initial="'RR'"
      ></PulseAndRiskDefinitions>
    </template>
    <div class="hyp-countries-map-container">
      <Map :id="mapId" @map-on-load="mapOnLoad"></Map>
    </div>
    <div class="hyp-countries-dialog-container">
      <v-card
        :style="styleCountries"
        class="hyp-countries-card-container hyp-countries-card-container-full-height"
      >
        <Countries
          class="hyp-countries-content-container"
          @close="handleClickClose()"
        />
      </v-card>
    </div>
  </SelectorPanel>
</template>

<script>
import { MAIN_MAP_ID } from "@/common/constants/maps";
import { RISK_RATING_PRIMARIES } from "@/common/constants/controlRisks/risks";
import {
  MODULE_PREFIX_MAP,
  MODULE_PREFIX_USER,
  MODULE_PREFIX_HOME,
} from "@/store";
import { mapGetters } from "vuex";
import lodashDebounce from "lodash/debounce";

export default {
  name: "CountriesSelector",
  components: {
    Map: () => import("@/components/map/Map"),
    SelectorPanel: () => import("@/components/common/SelectorPanel"),
    Countries: () => import("@/components/grd/countries/Countries"),
    PulseAndRiskDefinitions: () =>
      import("@/components/grids/PulseAndRiskDefinitions"),
  },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    dialogTop: 0,
    dialogCountries: false,
    mapId: MAIN_MAP_ID,
    forceClose: null,
    urlPath: "/grd/countries",
    selectedRatingId: RISK_RATING_PRIMARIES.security,
  }),
  computed: {
    ...mapGetters({
      maps: MODULE_PREFIX_MAP + "maps",
      selectorPanel: MODULE_PREFIX_HOME + "selectorPanel",
      preferences: MODULE_PREFIX_USER + "preferences",
    }),
    map() {
      return this.maps[MAIN_MAP_ID];
    },
    styleCountries() {
      return {
        width: `290px`,
        top: this.dialogTop,
        "z-index": "999999",
      };
    },
  },
  methods: {
    handleClickClose() {
      this.forceClose = new Date().toISOString();
    },
    async mapOnLoad(map) {
      // this.map.resize();
    },
    handleOpen() {
      this.dialogCountries = false;
      lodashDebounce(() => {
        this.dialogCountries = true;
      }, 5)();
      lodashDebounce(() => {
        this.map.resize();
      }, 500)();
    },
  },
};
</script>

<style scoped>
.hyp-countries-card-container {
  background-color: #f7f7fa !important;
  -webkit-box-shadow: 0 2px 7px 0 rgba(0, 0, 0, 0.14) !important;
  box-shadow: 0 2px 7px 0 rgba(0, 0, 0, 0.14) !important;
  border-top-right-radius: 5px !important;
  border-bottom-right-radius: 5px !important;
  min-height: 50px !important;
  position: absolute;
  top: 0;
}
.hyp-countries-card-container-full-height {
  bottom: 0;
  width: auto !important;
}
.hyp-countries-map-container {
  margin-left: 312px !important;
}
</style>
<style>
.v-card__text.hyp-dialog-risk-card-text {
  padding-right: 0 !important;
  height: 100% !important;
  padding-bottom: 0 !important;
}
.hyp-dialog-content-container.hyp-dialog-risk-card {
  padding: 0 !important;
}
</style>
